import { Link } from 'react-router-dom';
import { SuggestPlatformModal } from '@/components/shared/SuggestPlatformModal';
import { Lightbulb } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="w-full border-t border-border bg-muted/30 mt-auto">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>
            © {new Date().getFullYear()} GoCompareAI. For informational purposes only.
          </p>
          <div className="flex items-center gap-4">
            <SuggestPlatformModal 
              trigger={
                <button className="flex items-center gap-1.5 hover:text-foreground transition-colors">
                  <Lightbulb className="w-3.5 h-3.5" />
                  Suggest a platform
                </button>
              }
            />
            <Link 
              to="/about"
              className="hover:text-foreground transition-colors"
            >
              About
            </Link>
            <Link 
              to="/privacy"
              className="hover:text-foreground transition-colors"
            >
              Privacy
            </Link>
            <Link 
              to="/terms"
              className="hover:text-foreground transition-colors"
            >
              Terms
            </Link>
            <Link 
              to="/contact"
              className="hover:text-foreground transition-colors"
            >
              Contact
            </Link>
          </div>
        </div>
        <p className="text-xs text-muted-foreground/70 mt-4 text-center sm:text-left">
          This tool provides general information to help you explore AI platform options. 
          It does not constitute advice. Platform information may not be current — please verify 
          directly with providers before making decisions.
        </p>
      </div>
    </footer>
  );
};
